//types
export const ROCK_CHART_DATA = 'SET/3D/ROCK_CHART_DATA';
export const ROCK_CHART_DATA_COLOR = 'SET/3D/ROCK_CHART_DATA/COLOR';
export const CHART_ROCK_CHART_DATA = 'SET/3D/CHART_ROCKCHART_DATA';

//setter
export const setRockDataSet = obj => ({ type: ROCK_CHART_DATA, obj }) ;
export const setColor = colors => ({ type: ROCK_CHART_DATA_COLOR, colors });
export const setChartDataSet = chartDataSet => ({ type: CHART_ROCK_CHART_DATA, chartDataSet });
